module.exports = __webpack_public_path__ + "img/measurement_info_back_waist_right.3f6b0e1e.jpg";